/* Compare controls for Boost grids, including dynamically replaced product cards.
 * preezie owns the selection, limits and persistence; never write its storage key.
 */
(function () {
  'use strict';
  if (window.preezieBoostCompareLoaded) return;
  window.preezieBoostCompareLoaded = true;

  var cardSelector = '.boost-sd__product-item[data-product-id]';
  var buttonSelector = '.preezie-boost-compare';
  var storageKey = 'prz-ai-compare-state';
  var selected = new Set();

  function readSelection() {
    try {
      var state = JSON.parse(window.localStorage.getItem(storageKey) || 'null');
      selected = new Set(state && Array.isArray(state.products)
        ? state.products.filter(function (product) { return product && product.id != null; })
          .map(function (product) { return String(product.id); }) : []);
    } catch (error) {
      // Storage may be unavailable. Same-page events still maintain selection.
    }
  }

  function syncButton(button) {
    var active = selected.has(button.dataset.productId);
    var label = active ? 'Selected' : 'Compare';
    var pressed = String(active);
    if (button.textContent !== label) button.textContent = label;
    if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
  }

  function syncAll() {
    document.querySelectorAll(buttonSelector).forEach(syncButton);
  }

  function getImage(card) {
    var source;
    try {
      var product = JSON.parse(card.getAttribute('data-product') || '{}');
      var image = product.images && product.images[0];
      source = typeof image === 'string' ? image : image && image.src;
    } catch (error) { /* Fall back to the rendered image. */ }
    if (!source) {
      var img = card.querySelector('.boost-sd__product-image-img--main, .boost-sd__product-image img');
      source = img && (img.getAttribute('data-src') || img.currentSrc || img.getAttribute('src'));
    }
    try {
      var url = new URL(source || '', document.baseURI);
      return source && /^https?:$/.test(url.protocol) ? url.href : '';
    } catch (error) { return ''; }
  }

  function enhance(card) {
    var id = card.getAttribute('data-product-id');
    var imageUrl = getImage(card);
    var button = card.querySelector(buttonSelector);
    if (!id || !imageUrl) {
      if (button) button.remove();
      return;
    }
    if (!button) {
      var container = card.querySelector('.boost-sd__product-info') || card;
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'preezie-boost-compare';
      container.appendChild(button);
    }
    if (button.dataset.productId !== id) button.dataset.productId = id;
    if (button.dataset.imageUrl !== imageUrl) button.dataset.imageUrl = imageUrl;
    var title = card.querySelector('.boost-sd__product-title');
    var label = 'Compare ' + (title ? title.textContent.trim() : 'product');
    if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    syncButton(button);
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    var card = root.closest(cardSelector);
    if (card) enhance(card);
    root.querySelectorAll(cardSelector).forEach(enhance);
  }

  function announce(message) {
    var status = document.getElementById('preezie-boost-compare-status');
    if (!status) {
      status = document.createElement('div');
      status.id = 'preezie-boost-compare-status';
      status.setAttribute('role', 'status');
      document.body.appendChild(status);
    }
    status.textContent = message;
    status.hidden = !message;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(buttonSelector);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (typeof window.sendAIShoppingAssistantMessage !== 'function') {
      announce('Comparison is still loading. Please try again in a moment.');
      return;
    }
    announce('');
    try {
      var result = window.sendAIShoppingAssistantMessage({
        trigger: 'default',
        intent: 'ProductCompare',
        compareAction: selected.has(button.dataset.productId) ? 'remove' : 'add',
        products: [{ id: button.dataset.productId, imageUrl: button.dataset.imageUrl }]
      });
      if (result && typeof result.catch === 'function') result.catch(function () {
        announce('Comparison is unavailable right now. Please try again.');
      });
    } catch (error) {
      announce('Comparison is unavailable right now. Please try again.');
    }
    // Only the assistant's event confirms acceptance (including its product limit).
  }, true);

  document.addEventListener('przAIShoppingAssistantCompareUpdateEvent', function (event) {
    var detail = event.detail;
    if (!detail || !Array.isArray(detail.productIds) ||
        (detail.action !== 'add' && detail.action !== 'remove')) return;
    detail.productIds.forEach(function (id) {
      if (detail.action === 'add') selected.add(String(id));
      else selected.delete(String(id));
    });
    syncAll();
  });

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey || event.key === null) {
      readSelection();
      syncAll();
    }
  });
  window.addEventListener('pageshow', function () { readSelection(); syncAll(); });

  function start() {
    readSelection();
    scan(document.body);
    // Observe actual Boost markup, covering SSR, filtering, pagination and list view
    // without depending on a particular Boost component-library version.
    new MutationObserver(function (records) {
      var roots = new Set();
      records.forEach(function (record) {
        if (record.target.closest && record.target.closest(buttonSelector)) return;
        if (record.type === 'attributes') roots.add(record.target);
        else {
          if (record.target.closest && record.target.closest(cardSelector)) roots.add(record.target);
          record.addedNodes.forEach(function (node) { if (node.nodeType === 1) roots.add(node); });
        }
      });
      roots.forEach(scan);
    }).observe(document.body, {
      childList: true, subtree: true, attributes: true,
      attributeFilter: ['data-product-id', 'data-product', 'src', 'data-src']
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
